export function SocialMediaPolicy() {
    return <div className="font-mono  mx-auto px-4 py-10 leading-relaxed text-sm">
        <h1 className="text-2xl font-bold mb-6">Netstratum Social Media Policy</h1>

        <h2 className="text-xl font-bold mt-8 mb-3">1. Introduction</h2>
        <p className="mb-3">
            Netstratum Inc recognises the value of social media as a tool for communication, engagement, knowledge-sharing, and brand building...
        </p>
        <p className="mb-3">
            At the same time, we recognise that social media carries responsibility...
        </p>
        <p className="mb-2">This policy applies to -</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>All employees, contractors, consultants, interns, and board members...</li>
            <li>Anyone acting on behalf of Netstratum Inc...</li>
            <li>Any individual whose social media activity may have a bearing...</li>
        </ul>

        <h2 className="text-xl font-bold mt-8 mb-3">2. Our Official Social Media Channels</h2>
        <p className="mb-4">
            Netstratum Inc maintains official presences on the following platforms...
        </p>

        <table className="w-full border border-gray-300 border-collapse mb-6 text-sm">
            <thead>
                <tr className="bg-gray-100">
                    <th className="border border-gray-300 p-2 text-left font-semibold">Platform</th>
                    <th className="border border-gray-300 p-2 text-left font-semibold">Purpose</th>
                </tr>
            </thead>
            <tbody className="[&_tr:nth-child(even)]:bg-gray-50">
                <tr>
                    <td className="border border-gray-300 p-2">LinkedIn</td>
                    <td className="border border-gray-300 p-2">Professional networking and company updates</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">Instagram</td>
                    <td className="border border-gray-300 p-2">Brand content, team culture, and visual storytelling</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">Facebook</td>
                    <td className="border border-gray-300 p-2">Community engagement and company news</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">X (formerly Twitter)</td>
                    <td className="border border-gray-300 p-2">Real-time communications and industry commentary</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">YouTube</td>
                    <td className="border border-gray-300 p-2">Product demonstrations, webinars, and company content</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">Other platforms</td>
                    <td className="border border-gray-300 p-2">
                        Any other publicly accessible online platform...
                    </td>
                </tr>
            </tbody>
        </table>

        <p className="mb-4">
            Any content published through official Netstratum Inc channels must be authorised...
        </p>

        <h2 className="text-xl font-bold mt-8 mb-3">3. Our Community Standards</h2>
        <p className="mb-4">
            We welcome engagement with our community...
        </p>

        <h3 className="text-lg font-bold mt-6 mb-2">Content We Do Not Permit</h3>
        <p className="mb-2">
            The following types of content are not permitted...
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Abusive, defamatory, threatening...</li>
            <li>Personal attacks, intimidation...</li>
            <li>Slurs based on race, ethnicity...</li>
            <li>Content that is deliberately misleading...</li>
            <li>Spam, repetitive posts...</li>
            <li>Promotion of illegal activities...</li>
            <li>Promotion of political campaigns...</li>
            <li>Content that infringes intellectual property...</li>
            <li>Sexually explicit or inappropriate content...</li>
        </ul>

        <h3 className="text-lg font-bold mt-6 mb-2">Moderation</h3>
        <p className="mb-3">
            Netstratum Inc reserves the right to remove...
        </p>
        <p className="mb-4">
            All views and opinions expressed by third parties...
        </p>

        <h2 className="text-xl font-bold mt-8 mb-3">4. Guidelines for Employees - Personal Social Media Use</h2>

        <h3 className="text-lg font-bold mt-6 mb-2">4.1 During Working Hours</h3>
        <p className="mb-3">
            Personal use of social media during working hours is not permitted...
        </p>

        <h3 className="text-lg font-bold mt-6 mb-2">4.2 Protecting Confidential Information</h3>
        <p className="mb-3">
            Our confidentiality obligations apply at all times...
        </p>

        <h3 className="text-lg font-bold mt-6 mb-2">4.3 Photographs and Video on Company Premises</h3>
        <p className="mb-3">
            Prior written permission is required...
        </p>

        <h3 className="text-lg font-bold mt-6 mb-2">4.4 Representing Netstratum Inc</h3>
        <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Clearly state that your views are your own.</li>
            <li>Do not make unauthorised statements.</li>
            <li>Do not comment on legal matters.</li>
        </ul>

        <h3 className="text-lg font-bold mt-6 mb-2">4.5 Intellectual Property</h3>
        <p className="mb-3">
            Company intellectual property must not be used...
        </p>

        <h3 className="text-lg font-bold mt-6 mb-2">4.6 Respectful Conduct</h3>
        <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Do not post abusive content.</li>
            <li>Do not violate workplace standards.</li>
            <li>Do not misrepresent the company.</li>
        </ul>

        <h2 className="text-xl font-bold mt-8 mb-3">5. Representing Netstratum Inc on Social Media</h2>
        <p className="mb-4">
            Any employee representing the company on social media must obtain prior written approval...
        </p>

        <h2 className="text-xl font-bold mt-8 mb-3">6. Consequences of Non-Compliance</h2>
        <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>A formal warning.</li>
            <li>Suspension from social media activity.</li>
            <li>Demotion or reassignment.</li>
            <li>Termination of employment.</li>
            <li>Legal action where applicable.</li>
        </ul>

        <h2 className="text-xl font-bold mt-8 mb-3">7. External Engagement and User-Generated Content</h2>
        <p className="mb-4">
            Content posted by third parties represents their own views...
        </p>

        <h2 className="text-xl font-bold mt-8 mb-3">8. Policy Governance and Review</h2>
        <p>
            This policy is owned by the HR Department...
        </p>
    </div>


}